import React from "react";
// Energy Performance Report

// Custom
import Layout from "../../layout";

const EnergyPerformanceReport: React.FC = () => {
  const openInPopup = () => {
    window.open(
      "https://bi.voltreum.com/login",
      "PopupWindow",
      "width=800,height=600,scrollbars=yes"
    );
  };

  return (
    <Layout>
      <iframe
        src="https://bi.voltreum.com/login"
        //  src="https://en.wikipedia.org/wiki/Wikipedia:About"
        style={{ flexGrow: 1, width: "100%", border: "none" }}></iframe>
      {/* <button onClick={openInPopup}>
          click me
        </button> */}
    </Layout>
  );
};

export default EnergyPerformanceReport;
